import React from "react";
import { Helmet } from "react-helmet-async";
import PageUtil from "../helpers/page-util";
import TokenUtil from "../helpers/token-util";
import { getAppInsights } from "../settings/azure-insights-config";

const AppPageTitle = ({ pageTitle }) => {
  let user=TokenUtil.getIdentitySippioAccessTokenData();
if(user){
  let ai=getAppInsights();
ai.context.user.accountId= user?.accountNumber;
ai.context.user.authenticatedId= user?.zoomEmail??user?.userEmail;
}
  return (
    <Helmet>
      <title>{PageUtil.getHeadTitle(pageTitle)}</title>
    </Helmet>
  );
};

export { AppPageTitle };
